<template>
  <div>
    <DashboardHeader title="Manage Users">
      <v-row>
        <div class="mx-auto">
          <SnackBar :text="snackbarText" :colour="snackbarColor" :model="snackbarModel"></SnackBar>
        </div>
      </v-row>
      <v-layout row wrap>
        <v-flex xs12 md3 class="mx-5 mt-4">
          <v-card v-if="isManager" shaped elevation="12" max-width="344" outlined>
            <v-list-item class="mt-4">
              <v-autocomplete
                prepend-inner-icon="search"
                v-model="selectedUserId"
                item-text="email"
                item-value="id"
                :items="users"
                solo-inverted
                flat
                hide-details
                label="Search User"
                @change="getSelectedUser()"
              ></v-autocomplete>
            </v-list-item>
            <v-row>
              <v-card-title class="mx-auto my-0">OR</v-card-title>
            </v-row>
            <v-text-field
              solo-inverted
              prepend-inner-icon="search"
              v-model="searchUserEmail"
              class="mx-4"
              label="Search Entire Database"
            ></v-text-field>
            <v-btn
              class="ml-4 mb-4"
              :color="getThemeColor"
              dark
              rounded
              @click="searchUserFromEntireDatabase()"
            >Search Database</v-btn>
          </v-card>

          <v-card
            class="mt-4"
            shaped
            elevation="12"
            max-width="344"
            outlined
            v-if="selectedUser != null && isManager"
          >
            <v-list-item three-line>
              <v-list-item-content>
                <v-row class="overline mb-4">
                  <span class="mx-4">User Profile</span>
                  <v-btn small rounded class="mt-1" color="warning" @click="dialog=true">
                    <v-icon left>mdi-link</v-icon>Link Student to User
                  </v-btn>
                </v-row>

                <v-list-item-title class="headline mb-1">{{selectedUser.name}}</v-list-item-title>
                <v-list-item-subtitle>{{selectedUser.sid}}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar tile size="80" :color="getThemeColor">
                <v-img
                  size="80"
                  scr="https://static.vecteezy.com/system/resources/previews/000/620/163/non_2x/circle-logo-and-symbols-vector.jpg"
                ></v-img>
              </v-list-item-avatar>
            </v-list-item>

            <v-list two-line>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-phone</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{selectedUser.phone_number}}</v-list-item-title>
                  <v-list-item-subtitle>Contact Number</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-icon>
                  <v-icon>mdi-message-text</v-icon>
                </v-list-item-icon>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-email</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{selectedUser.email}}</v-list-item-title>
                  <v-list-item-subtitle>Main</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-account-key</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{selectedUser.employee_id}}</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-select
                      class="mx-3"
                      :items="alevels"
                      :label="'Access Level: '+selectedUser.alevel + ' ['+selectedUser.role+']'"
                      v-model="selectedAlevel"
                      @change="grantAccessLevel()"
                    ></v-select>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-card-actions>Last Seen: {{selectedUser.last_seen}}</v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 md8>
          
          <v-card>
            <v-row class="mt-4 mx-4">
              <v-spacer></v-spacer>
            <v-select
              :items="statuses"
              v-model="status"
              label="Manage Users"
              @change="getSelectedValue()"
              v-if="isManager"
            ></v-select>
          </v-row>

            <v-card-title>
              {{tableTitle}}
              <v-btn
                class="mx-4"
                rounded
                :color="getThemeColor"
                dark
                small
                @click="openDailogInvite()"
              >Invite Users</v-btn>
              <v-btn
                class="mx-4"
                rounded
                color="warning"
                dark
                small
                @click="openDailogApplyClass()"
              >Apply Class</v-btn>
               <v-btn
                class="mx-4"
                rounded
                color="red"
                dark
                small
                @click="openDailogDeleteUsers()"
              >Delete</v-btn>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>

            <v-data-table :headers="headersAc" :items="usersAc" :search="search">
              <template v-slot:item.selection="{item}">
                <v-checkbox
                  class="shrink"
                  :value="item.id"
                  v-model="selectedUsers"
                ></v-checkbox>
                <v-icon @click="openDialogViewCourses(item.id)">mdi-account-details</v-icon>
              </template>
              <template v-slot:item.action="{ item }">
                <v-chip
                  v-if="item.banned_at"
                  class="ma-2"
                  small
                  color="orange"
                  dark
                  @click="unbanUser(item)"
                >
                  <v-icon left>mdi-account-check</v-icon>Unban
                </v-chip>

                <div v-else>
                  <v-textarea
                    v-if="isManager"
                    :ref="'user_'+item.id"
                    clearable
                    rows="1"
                    clear-icon="cancel"
                    label="Reason"
                  ></v-textarea>
                  <v-chip
                    class="ma-2"
                    v-if="isManager"
                    small
                    color="red"
                    dark
                    @click="banUser(item)"
                  >
                    <v-icon left>mdi-account-remove</v-icon>Ban
                  </v-chip>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
        <div class="text-center">
          <v-dialog v-model="dialog" width="500">
            <v-card v-if="selectedUser && !inviteUser">
              <v-card-title
                :style="{'background-color':getThemeColor,'color':'white'}"
                class="headline lighten-2"
              >Linking Student to: {{selectedUser.name}}</v-card-title>

              <v-autocomplete
                class="mx-3"
                :items="students"
                prepend-icon="mdi-magnify"
                label="Search Student"
                v-model="selectedStudent"
              ></v-autocomplete>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :color="getThemeColor" @click="linkParentToStudent()" dark>
                  <v-icon left>mdi-link</v-icon>Link
                </v-btn>
                <v-btn color="primary" @click="closeDialog()">Cancel</v-btn>
              </v-card-actions>
            </v-card>
            <v-card v-if="inviteUser">
              <v-card-title
                :style="{'background-color':getThemeColor,'color':'white'}"
                class="headline lighten-2"
              >Invite User</v-card-title>
              <v-form v-model="invitationForm">
                <v-text-field
                  :rules="nameRules"
                  v-model="userName"
                  class="mx-10"
                  prepend-icon="mdi-account"
                  label="User Names"
                ></v-text-field>
                <v-text-field
                  :rules="emailRules"
                  v-model="userEmail"
                  class="mx-10"
                  prepend-icon="mdi-mail"
                  label="User Email"
                ></v-text-field>
                <v-text-field
                  :rules="nameRules"
                  v-model="userPhone"
                  class="mx-10"
                  prepend-icon="mdi-phone"
                  label="User Phone"
                ></v-text-field>

                <v-autocomplete
                  :items="students"
                  v-model="userSid"
                  class="mx-10"
                  label="User SID"
                  prepend-icon="mdi-numeric"
                ></v-autocomplete>

                <v-select
                  class="mx-10"
                  :rules="nameRules"
                  prepend-icon="mdi-lock"
                  :items="alevels"
                  label="Access Level"
                  v-model="userAccess"
                ></v-select>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn :color="getThemeColor" @click="InviteSomeone()" dark>
                    <v-icon left>mdi-account-plus</v-icon>Invite
                  </v-btn>
                  <v-btn color="red" dark @click="closeDialog()">Cancel</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>


            <v-card v-else-if="applyClass">
               <v-card-title
                :style="{'background-color':getThemeColor,'color':'white'}"
                class="headline lighten-2"
              >Apply Class/Group to Selected Users</v-card-title>

               <v-select
                  class="mx-10"
                  :rules="nameRules"
                  prepend-icon="mdi-lock"
                  :items="classes"
                  label="Class Groups"
                  v-model="selectedClass"
                ></v-select>

                 <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn :color="getThemeColor" @click="applyClassToSelectedUsers()" dark>
                    <v-icon left>mdi-check</v-icon>Apply Class
                  </v-btn>
                  <v-btn color="red" dark @click="closeDialog()">Cancel</v-btn>
                </v-card-actions>
            </v-card>

            <v-card v-else-if="deleteUser">
              <v-card-title
                :style="{'background-color':getThemeColor,'color':'white'}"
                class="headline lighten-2"
              >Delete Selected Users</v-card-title>

              <v-card-text>
                You Are About To Delete The Selected Users
              </v-card-text>

              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red" @click="DeleteSelectedUsers()" dark>
                    <v-icon left>mdi-account-minus</v-icon>Delete
                  </v-btn>
                  <v-btn color="warning" dark @click="closeDialog()">Cancel</v-btn>
                </v-card-actions>
            </v-card>

            <v-card v-else-if="viewCourses">
              <v-card-title
                :style="{'background-color':getThemeColor,'color':'white'}"
                class="headline lighten-2"
              >Groups / Classes</v-card-title>

              <v-card-title v-for="(course,i) in courses" :key="i+Math.random()">
                {{i + 1}}) {{course.lesson_group}}
              </v-card-title>

              <v-card-actions>
                  <v-spacer></v-spacer>
                  
                  <v-btn color="red" dark @click="closeDialog()">Cancel</v-btn>
                </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-layout>
    </DashboardHeader>
  </div>
</template>

<script>
import DashboardHeader from "@/components/DashboardHeader";
import axios from "@/plugins/axios";
import SnackBar from "@/components/myLibrary/SnackBar.vue";

export default {
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isManager() {
      return this.$store.getters.isManager;
    }
  },
  mounted() {
    this.mountUsers()
  },
  components: {
    DashboardHeader,
    SnackBar
  },
  data: () => ({
    courses:[],
    selectedUsers:[],
    selectedClass:null,
    classes:[],
    searchUserEmail: null,
    alevels: [
      { text: "Everybody [1]", value: 1 },
      { text: "Parent [3]", value: 3 },
      { text: "Staff [5]", value: 5 },
      { text: "Admin [7]", value: 7 },
      { text: "Manager [9]", value: 9 },
      { text: "Super Admin [11]", value: 11 }
    ],
    dialog: false,
    invitationForm: null,
    inviteUser: false,
    applyClass:false,
    deleteUser:false,
    viewCourses:false,
    snackbar: false,
    snackbarText: "",
    snackbarColor: "",
    snackbarModel: false,
    snackbarModel2: false,
    snackbarModel3: false,
    students: [],
    valid: false,
    selectedUserId: "",
    selectedUser: null,
    selectedUserId2: "",
    selectedAlevel: "",
    selectedAlevel2: "",
    selectedStudent: "",
    userEmail: null,
    userName: null,
    userAccess: null,
    userPhone: null,
    userSid: null,
    nameRules: [v => !!v || "Field is required"],
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ],
    text: "Hello,  a snackbar",
    status: null,
    tableTitle: "All Users",
    statuses: [
      { text: "All Users", value: "all" },
      { text: "Active Users", value: "unban" },
      { text: "Deactivated Users", value: "ban" }
    ],
    search: "",
    headers: [
      {
        text: "Full Names",
        align: "start",
        value: "name"
      },
      { text: "Email", value: "email" },
      { text: "Access Level", value: "alevel" },
      { text: "Actions", value: "actions" }
    ],
    headersAc: [
      {text:'Selection',value:'selection'},
      {
        text: "User",
        align: "start",
        value: "name"
      },
      { text: "Email", value: "email" },
      { text: "Access Level", value: "alevel" },
      { text: "Student", value: "sid" },
      { text: "Actions", value: "action" }
    ],
    users: [],
    usersAc: []
  }),
  methods: {
    mountUsers(){
      
    this.$store.commit("setLoader", true);
    axios.getData("/auth/get-all-users", this.getAccessToken).then(users => {
      this.users = users;

      this.$store.commit("setLoader", true);
      axios
        .getData("/auth/get-all-students", this.getAccessToken)
        .then(students => {
          this.$store.commit("setLoader", false);
          students.forEach(student => {
            this.students.push({
              text:
                student.lname + " " + student.fname + "[ " + student.sid + " ]",
              value: student.sid
            });
          });
          axios
            .getData("/auth/get-users-access-links", this.getAccessToken)
            .then(usersAc => {
              this.usersAc = usersAc;
            });
        });
    });
  
    },
    getSelectedValue() {
      if (this.status == "ban") {
        this.tableTitle = "Deactivated Accounts";
      } else if (this.status == "unban") {
        this.tableTitle = "Active Accounts";
      } else {
        this.tableTitle = "All User Accounts";
      }
      axios
        .postDataWithToken(
          "/auth/get-specific-users",
          { filter: this.status },
          this.getAccessToken
        )
        .then(response => {
          this.usersAc = response;
        });
    },
    banUser(user) {
      const reason = this.$refs["user_" + user.id].lazyValue;

      if (reason != undefined) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/ban-user",
            { user: user, reason: reason },
            this.getAccessToken
          )
          .then(response => {
            this.$store.commit("setLoader", false);
            this.tableTitle = "Deactivated Accounts";
            this.status = { text: "Deactivated User Accounts", value: "ban" };
            this.usersAc = response;
          });
      } else {
        alert("provide reason for account deactivation!");
      }
    },
    unbanUser(user) {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/unban-user",
          { user: user },
          this.getAccessToken
        )
        .then(response => {
          this.$store.commit("setLoader", false);
          this.tableTitle = "Active Accounts";
          (this.status = { text: "Active User Accounts", value: "unban" }),
            (this.usersAc = response);
        });
    },
    grantAccessLevel() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/grant-access-level",
          { user: this.selectedUser, alevel: this.selectedAlevel },
          this.getAccessToken
        )
        .then(usersAc => {
          this.$store.commit("setLoader", false);
          this.snackbarText = "Access Level Granted Successfully!";
          this.snackbarColor = "success";
          this.snackbarModel = true;
          this.usersAc = usersAc;
        });
    },
    linkParentToStudent() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/link-parent-to-student",
          { userId: this.selectedUser.id, sid: this.selectedStudent },
          this.getAccessToken
        )
        .then(usersAc => {
          this.$store.commit("setLoader", false);

          this.snackbarText = "Parent Successfully Linked to Student!";
          this.snackbarColor = "success";
          this.usersAc = usersAc;

          this.dialog = false;
          this.snackbarModel = true;
        });
    },
    InviteSomeone() {
      if (this.invitationForm) {
        this.$store.commit("setLoader", true);
        const userName = this.userName;
        const userPhone = this.userPhone;
        const userEmail = this.userEmail;
        const userAccess = this.userAccess;
        const userSid = this.userSid;
        const userDomain = window.location.hostname;

        axios
          .postDataWithToken(
            "/auth/invite-someone",
            { userName, userPhone, userEmail, userAccess, userSid, userDomain },
            this.getAccessToken
          )
          .then(response => {
            this.$store.commit("setLoader", false);
            if (response == "success") {
              this.snackbarText = "Invitation Successfully Sent!";
              this.snackbarColor = "success";
              this.closeDialog();
            } else {
              this.snackbarText = "Oops, Email Already Exist!";
              this.snackbarColor = "error";
              this.closeDialog();
            }
            this.snackbarModel = true;
          });
      }
    },
    getSelectedUser() {
      const userId = this.selectedUserId;
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-user-by-id",
          { userId },
          this.getAccessToken
        )
        .then(user => {
          this.selectedUser = null;
          this.$store.commit("setLoader", false);
          this.selectedUser = user;
        });
    },
    searchUserFromEntireDatabase() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-user-by-email",
          { userEmail: this.searchUserEmail },
          this.getAccessToken
        )
        .then(user => {
          this.selectedUser = null;
          this.$store.commit("setLoader", false);
          this.selectedUser = user;
        });
    },
    closeDialog() {
      this.dialog = false;
      this.inviteUser = false;
      this.applyClass = false
      this.deleteUser = false
      this.viewCourses = false
    },
    openDailogInvite() {
      this.dialog = true;
      this.inviteUser = true;
    },
    openDailogApplyClass(){
      if(this.selectedUsers.length < 1){
        alert('You Must Select At Least 1 User')
        event.preventDefault()
      }else{
        this.$store.commit('setLoader',true)
        axios.getData('/auth/get-all-classes',this.getAccessToken).then(cls => {
          this.classes = []
          cls.forEach(cl => {
            this.classes.push({text:cl.class_name,value:cl.class_name})
          })
          
          this.$store.commit('setLoader',false)
          this.dialog = true
          this.applyClass = true;
        })
        
      }
    },
    openDailogDeleteUsers(){
      if(this.selectedUsers.length < 1){
        alert('You Must Select At Least 1 User')
        event.preventDefault()
      }else{
        this.dialog = true
        this.deleteUser = true
      }
    },
    openDialogViewCourses(id){
      this.$store.commit('setLoader',true)
      axios.postDataWithToken('/auth/get-courses-for-user',{userID:id},this.getAccessToken).then(courses => {
        this.courses = courses
        this.$store.commit('setLoader',false)
           this.dialog = true
          this.viewCourses = true
      })
   
    },
    applyClassToSelectedUsers(){
      this.$store.commit('setLoader',true)
      axios.postDataWithToken('/auth/apply-class-to-selected-users',{selectedUsers:this.selectedUsers,selectedClass:this.selectedClass},this.getAccessToken).then(() => {
       this.closeDialog()
       this.$store.commit('setLoader',false)
        this.mountUsers()
      })
    },
    DeleteSelectedUsers(){
      this.$store.commit('setLoader',true)
      axios.postDataWithToken('/auth/delete-selected-users',{selectedUsers:this.selectedUsers},this.getAccessToken).then(() => {
        this.$store.commit('setLoader',false)
        this.closeDialog()
        this.mountUsers()
      })
    }
  }
};
</script>

<style>
</style>